import React, { useMemo } from 'react';

import classNames from 'classnames';

import CheckboxInput from 'CommonComponents/CheckboxInput';
import Tags from 'CommonComponents/Tags';
import TextButton from 'CommonComponents/TextButton';

import ChevronDown from 'Assets/icons/chevron-down.svg';
import ChevronUp from 'Assets/icons/chevron-up.svg';
import EditIcon from 'Assets/icons/edit.svg';
import TrashIcon from 'Assets/icons/trash.svg';

export default function CentralAssumptionsTableGroupRow({
    assumptionGroup,
    onEdit,
    onDelete,
    deletable,
    toggleDeletableRow,
    checkedForDeletion,
    showSourceColumn,
    ...props
}) {
    const sourceNames = useMemo(() => {
        if (!assumptionGroup.source_names) {
            return [$t('Master')];
        }
        try {
            return JSON.parse(assumptionGroup.source_names);
        } catch (e) {
            console.error('Error parsing source names for assumption group ID ' + assumptionGroup.id, e);
            return null;
        }
    }, [assumptionGroup.source_names]);

    return (
        <div className="tw-flex tw-py-2">
            <div className="tw-basis-3/12 tw-px-2 tw-flex tw-items-center tw-gap-x-2">
                <div className="tw-basis-4">{deletable && <CheckboxInput checked={checkedForDeletion} onChange={(e) => toggleDeletableRow()} />}</div>
                <div className="tw-flex tw-items-center tw-gap-x-2">
                    <p className="tw-text-sm tw-font-semibold">{assumptionGroup.title}</p>

                    <div className="tw-flex tw-items-center tw-self-center tw-cursor-pointer" onClick={props.toggleExpanded}>
                        {props.expanded && <ChevronUp className="tw-h-3 tw-w-3 tw-mx-auto tw-my-auto" />}
                        {!props.expanded && <ChevronDown className="tw-h-3 tw-w-3 tw-mx-auto tw-my-auto" />}
                    </div>
                </div>
            </div>
            {showSourceColumn && (
                <div className="tw-basis-3/12 tw-px-2 tw-flex tw-items-center">
                    <Tags tags={sourceNames} />
                </div>
            )}
            <div className={classNames('tw-px-2', { 'tw-basis-4/12': showSourceColumn, 'tw-basis-7/12': !showSourceColumn })}></div>
            <div className="tw-basis-1/12 tw-px-2"></div>
            <div className="tw-basis-1/12 tw-px-2">
                <div className="tw-flex tw-items-center tw-gap-x-3">
                    {!!props.canUpdate && (
                        <TextButton onClick={() => onEdit(assumptionGroup)}>
                            <EditIcon className="tw-w-3 tw-h-3" />
                            {$t('Edit')}
                        </TextButton>
                    )}
                    {!!props.canDelete && (
                        <TextButton variant="danger" onClick={() => onDelete(assumptionGroup)}>
                            <TrashIcon className="tw-w-3 tw-h-3" />
                            {$t('Delete')}
                        </TextButton>
                    )}
                </div>
            </div>
        </div>
    );
}
